module.exports = __webpack_public_path__ + "img/okpay.93bfaaeb.svg";